import type {
  CatalogTypeFiltersModel,
  CatalogTypesModel,
  GetMobileMenuTreeQuery,
  TopMenuSpecialModel
} from '@schema/cart';

export enum CatalogMenuItemType {
  Product = 'product',
  Service = 'service'
}

export interface CatalogMenuItem {
  id: CatalogTypesModel['id'];
  type: CatalogMenuItemType;
  isActive: boolean;
  isBarMenu: boolean;
  icon?:
    | string
    | {
        x1: typeof import('*.png') | string;
        x2: typeof import('*.png') | string;
        x3: typeof import('*.png') | string;
      };
  identify: CatalogTypesModel['identify'];
  title: CatalogTypesModel['title'];
  childrenItems: Array<
    CatalogTypesModel & { url: string; isActive: boolean; icon?: string }
  > | null;
  rubricGroup?: Array<
    CatalogTypeFiltersModel & {
      url: string;
    }
  > | null;
  rubticProductsCount?: GetMobileMenuTreeQuery['getMobileMenuTree'][0]['rubticProductsCount'];
  rubricGroupTitle?: GetMobileMenuTreeQuery['getMobileMenuTree'][0]['rubricGroupTitle'];
  url: string;
  isHidden?: boolean;
}

export type CatalogSpecialMenuItem = TopMenuSpecialModel;
